import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, memo } from 'react';
import { useTheme } from 'styled-components';
import { ItemHeaderWrapper, ItemIcon, ItemTitle, ItemTitleText, Label } from './styled';
export const HeaderWrapper = memo(function HeaderWrapper({ match, icon, title, label }) {
    const theme = useTheme();
    const clonedIcon = cloneElement(icon, {
        filled: !!match,
        color: match ? theme.colors.main : theme.colors.grey100_1,
        size: 20,
    });
    return (_jsxs(ItemHeaderWrapper, { children: [_jsx(ItemIcon, { children: clonedIcon }), _jsxs(ItemTitle, { children: [_jsx(ItemTitleText, { children: title }), label && _jsx(Label, { children: label })] })] }));
});
